import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { X, ShieldCheck } from 'lucide-react';

const CookieBanner: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { t } = useLanguage();

    useEffect(() => {
        const consent = localStorage.getItem('mm-cookie-consent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('mm-cookie-consent', 'accepted');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-6 right-6 z-[100] animate-in fade-in slide-in-from-bottom-5 duration-500">
            <div className="bg-white/95 backdrop-blur-md border border-maat-sand rounded-2xl p-6 shadow-2xl max-w-sm relative overflow-hidden">
                {/* Subtle decorative accent */}
                <div className="absolute top-0 left-0 w-1 h-full bg-maat-gold/40"></div>

                <div className="space-y-4">
                    <div className="flex items-center space-x-2">
                        <ShieldCheck size={18} className="text-maat-gold" />
                        <h3 className="text-sm font-serif font-bold text-maat-blue tracking-wide uppercase">
                            {t.legal.cookieBanner.title}
                        </h3>
                    </div>

                    <p className="text-sm leading-relaxed text-maat-blue/80">
                        {t.legal.cookieBanner.message}{' '}
                        <Link to="/privacy-statement" className="text-maat-gold font-bold hover:underline">
                            {t.legal.cookieBanner.linkText}
                        </Link>.
                    </p>

                    <div className="pt-2">
                        <button
                            onClick={handleAccept}
                            className="w-full bg-maat-blue text-maat-stone py-2 rounded-xl text-sm font-bold hover:bg-maat-gold hover:text-maat-blue transition-all transform active:scale-95 shadow-sm"
                        >
                            {t.legal.cookieBanner.accept}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
